import A11y from './a11y';

class SearchBar {
    constructor($element, topBar) {
        this.$searchWrap = $element;
        this.topBar = topBar;
        this.$searchTrigger = document.querySelectorAll('.js-search-trigger');
        this.$searchClose = $element.querySelector('.js-search-close');
        this.$searchInput = $element.querySelector('.header-search-query');
        this.$searchBox = $element.querySelector('.header-search-box');

        if (!this.$searchTrigger || !this.$searchBox) {
            return;
        }

        this.isResultsPage = document.body.classList.contains('search-open-no-overlay');

        this.init();
    }

    init() {
        for (let el of this.$searchTrigger) {
            el.addEventListener('click', this.open.bind(this));
        }
        this.$searchClose.addEventListener('click', this.close.bind(this));
        this.$searchInput.addEventListener('focus', this.focus.bind(this));
        this.$searchInput.addEventListener('blur', this.blur.bind(this));
        document.body.addEventListener('menu', this.toggleMenu.bind(this));

        if (this.isResultsPage) {
            this.topBar.disable(this.$searchBox);
        }
    }

    open() {
        document.body.classList.add('search-open');

        if (this.isResultsPage) {
            this.topBar.disable(this.$searchBox);
        } else {
            this.topBar.toggleMenu(true);
            this.a11yHandlers = A11y.focusTrap(this.$searchBox, this.$searchTrigger[0], this.close.bind(this));
        }

        setTimeout(() => { // fix for trigger button remaining focused instead
            this.$searchInput.focus();
            this.$searchInput.select();
        }, 100);
    }

    close(doCloseMenu = true) {
        if (doCloseMenu) {
            this.topBar.toggleMenu(false);
        }

        if (this.isResultsPage) {
            this.topBar.enable(this.$searchBox);
        }

        if (this.a11yHandlers) this.a11yHandlers = A11y.removeFocusTrap(this.a11yHandlers);

        document.body.classList.remove('search-open');
        // document.body.classList.remove('search-open-no-overlay');
    }

    toggleMenu(data) {
        let isOpen = data.detail;

        if (!isOpen) {
            this.close(false);
        }
    }

    focus() {
        this.$searchWrap.classList.add('search-focus');
    }

    blur() {
        this.$searchWrap.classList.remove('search-focus');
    }
}

export default SearchBar;
